"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDateFilterForDateDataset = exports.mergeFiltersWithDashboard = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var internal_1 = require("../internal");
/**
 * Gets filters merged with the filters provided by the specified dashboard.
 *
 * @param dashboard - dashboard to get the filters from
 * @param additionalFilters - filters to apply on top of the filters from the dashboard
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. Superseded by Dashboard component; please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
function mergeFiltersWithDashboard(dashboard, additionalFilters) {
    var _a, _b;
    var sanitizedAdditionalFilters = internal_1.filterArrayToFilterContextItems(additionalFilters !== null && additionalFilters !== void 0 ? additionalFilters : []);
    return tslib_1.__spreadArrays(((_b = (_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.filterContext) === null || _a === void 0 ? void 0 : _a.filters) !== null && _b !== void 0 ? _b : []), sanitizedAdditionalFilters);
}
exports.mergeFiltersWithDashboard = mergeFiltersWithDashboard;
function hasDateFilterForDateDataset(filters, dateDataset) {
    return filters.some(function (filter) {
        if (!sdk_model_1.isDateFilter(filter)) {
            return false;
        }
        return sdk_model_1.areObjRefsEqual(sdk_model_1.filterObjRef(filter), dateDataset);
    });
}
exports.hasDateFilterForDateDataset = hasDateFilterForDateDataset;
//# sourceMappingURL=mergeFiltersWithDashboard.js.map